import { AbsDeliveryCharge } from './AbsDeliveryCharge';
export class DeliveryChargeDelete extends AbsDeliveryCharge {
    storeId = '';
    checkedList = [];
    constructor(data) {
        super(data);
        Object.assign(this, {
            storeId: data.storeId,
            checkedList: data.checkedList,
        });
    }
    createReqBody() {
        return {
            ids: this.checkedList,
        };
    }
}
